enum ThemeColor {
  Acceligent = '#F1CA4B',
  Audubon = '#BDE9FA',
  LearnRAG = '#6830F7',
  QAnt = '#BB6BD9',
  Squadlocker = '#599D13',
  Navigation = '#6830f7',
  Default = '#FFFFFF',
  Pista = '#CE7312',
}

export default ThemeColor
